import { z } from 'zod';
import { TimestampSchema } from './common';
import { SessionId, UserId } from './ids';

export const SessionIndexEntrySchema = z.object({
  sessionId: SessionId,
  userId: UserId,
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
  deletedAt: TimestampSchema.optional(),
});

export type SessionIndexEntry = z.infer<typeof SessionIndexEntrySchema>;
